import { Outlet } from "react-router-dom";
import { AppRouteProps } from "src/components/router/AppRoute";
import CreateTab, { registerWrapperComponent } from "src/hooks/useTab";
import React from "react";
import { wrapRoutes } from "src/components/router/AuthWrapper";
import Ration from "./diet-process";
import DietRequestsDoctor from "./diet-requests-doctor";
import DietRequestsRefectory from "./diet-requests-refectory";

// Wrapper component'leri başlangıçta register et
registerWrapperComponent('/diet-process', () => React.createElement(Ration));
registerWrapperComponent('/diet-requests-doctor', () => React.createElement(DietRequestsDoctor));
registerWrapperComponent('/diet-requests-refectory', () => React.createElement(DietRequestsRefectory));

export const dietProcessRoutes: AppRouteProps[] = [
  {
    path: "diet-defination",
    element: (
      <NurseLayout>
        <Outlet />
      </NurseLayout>
    ),
    children: wrapRoutes([  
      { path: "diet-process", element: <DietWrapper title="Diyet Tanımları" element={Ration} path="/diet-process" />, role: "frmRationProcess" },
      { path: "diet-requests-doctor", element: <DietWrapper title="Diyet İstekleri (Doktor)" element={DietRequestsDoctor} path="/diet-requests-doctor" />, role: "frmDietRequestsDoctor" },
      { path: "diet-requests-refectory", element: <DietWrapper title="Diyet İstekleri (Yemekhane)" element={DietRequestsRefectory} path="/diet-requests-refectory" />, role: "frmDietRequestsRefectory" },
    ]),
  },
];

function NurseLayout(props: any) {
    return <>{props.children}</>;
}

function DietWrapper({ title, element: Element, path }: { title: string; element: any; path: string }) {
  return <CreateTab title={title} element={<Element />} path={path} />;
}

